module.exports = __webpack_public_path__ + "images/patterns/pattern-dark_ba45bdbe5bfd2ec67435d5e1ad05006b.svg";